import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@getgo/chameleon-web-react-wrapper';

import RazorpayIcon from 'assets/RazorpayIcon.svg';
import DefaultDeleteCTAs from 'components/default-delete-ctas';
import usePermissions from 'hooks/usePermissions';
import { Section } from 'lib/roles/roles-constant';
import { RazorPayAccounts } from 'types/payment-method';
import { PAYMENT_METHODS_TYPES } from 'utils/constants';
import { getSupportedCCInfo } from 'utils/credit-card-utils';

import './razorpay-info.css';

interface RazorpayInfoProps {
  razorpay: RazorPayAccounts;
}

const RazorpayInfo: FC<RazorpayInfoProps> = ({ razorpay }): JSX.Element => {
  const intl = useIntl();
  const { hasPermission } = usePermissions();

  const cardInfo = getSupportedCCInfo(razorpay.type.toUpperCase(), intl);

  return (
    <section className="razorpay-info">
      <div className="razorpay-info__details">
        <RazorpayIcon />
        <Typography tag="h3" variant="body-small" gutterBottom>
          <div className="razorpay-info__icon-num">
            {cardInfo.cardIcon}
            <Typography variant="body-small">**** **** **** {razorpay.last4Digits}</Typography>
          </div>
        </Typography>
      </div>
      {hasPermission(Section.modifyPaymentMethod) && (
        <DefaultDeleteCTAs
          isDefault={razorpay.isDefault}
          paymentMethodKey={razorpay.paymentMethodKey}
          isDeletable={razorpay.isDeletable}
          paymentType={PAYMENT_METHODS_TYPES.razorpay}
        />
      )}
    </section>
  );
};

export default RazorpayInfo;
